/**
 * API functions for public video endpoints (anonymous sharing without tracking)
 */

import { apiClient } from "./apiClient";

export interface PublicVideoData {
  video: {
    id?: string;
    project_id?: string;
    s3_path: string | null;
    download_url: string | null;
    file_size: number;
    storage_provider: string;
    bunny_video_id: string | null;
    encoding_status: string | null;
    encoding_progress: number | null;
    thumbnail_url: string | null;
    preview_url: string | null;
    duration: number | null;
    width: number | null;
    height: number | null;
    available_resolutions: string | null;
    embed_url: string | null;
  };
  project: {
    name: string;
    logo_url: string | null;
    banner_url: string | null;
    background_url: string | null;
    description: string | null;
    colors: {
      form_background: string;
      text_color: string;
      button_gradient_start: string;
      button_gradient_end: string;
      button_text_color: string;
    } | null;
  };
}

/**
 * Fetch public video data by slug
 * Public endpoint - no auth required, no tracking
 */
export async function fetchPublicVideo(slug: string): Promise<PublicVideoData> {
  return apiClient<PublicVideoData>(`/s/${slug}`, { requiresAuth: false });
}
